import React, { Component } from 'react';
import './App.css';
import Header from './components/Header'
import WritingArea from './components/WritingArea'
import WebsitesArea from './components/WebsitesArea'
import SocialMediaArea from './components/SocialMediaArea'
import WebsiteControlPanel from './components/WebsiteControlPanel'
import PartySidePanels from './components/PartySidePanels'
import Safe from './components/Safe'
import SnoozeArea from './components/SnoozeArea'

class App extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       nickname: ""
    }
  }
  setNickname = (newNickname) => {
    this.setState({
      nickname: newNickname
    });
  }
  
  render(){
    return (
      <div className="App">
        <Header nickname={this.state.nickname}></Header>
        <PartySidePanels></PartySidePanels>
        <div className="horizontallyCentered">
          <Safe></Safe>
          <WritingArea></WritingArea>
          <WebsitesArea></WebsitesArea>
          <SocialMediaArea></SocialMediaArea>
          <WebsiteControlPanel setNickname={this.setNickname}></WebsiteControlPanel>
          <SnoozeArea></SnoozeArea>
        </div>
      </div>
    );
  }
}

export default App;
